import { FunctionComponent } from 'react';
import {
  COUNTRIES,
  OrganizationInformationCard,
  OrganizationInformationCardTranslations,
  OrganizationInformationEditModal,
  OrganizationInformationEditModalTranslations,
} from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { UserOrganizationRequest, UserOrganizationResponse } from '@cdaas/api-clients/dist/asset-user-openapi';

interface BasicInformationProps {
  organization: UserOrganizationResponse;
  showModal: boolean;
  onClickEdit: () => void;
  updateOrganizationBasicInfo: (values: Pick<UserOrganizationRequest, 'default_billing_address' | 'default_billing_contact'>) => Promise<boolean>;
  cancelOrganizationBasicInfo: () => void;
}

export const BasicInformation: FunctionComponent<BasicInformationProps> = ({
  organization,
  showModal,
  onClickEdit,
  updateOrganizationBasicInfo,
  cancelOrganizationBasicInfo,
}) => {
  const { t } = useTranslation('editOrganization');
  const { t: tGlobal } = useTranslation('globalComponents');

  const organizationInformationCardTranslations: OrganizationInformationCardTranslations = {
    title: t('organizationSettingsPage.basicInformation.title'),
    nameRowTitle: t('organizationSettingsPage.basicInformation.nameRowTitle'),
    billingAddressRowTitle: t('organizationSettingsPage.basicInformation.billingAddressRowTitle'),
    billingContactPersonRowTitle: t('organizationSettingsPage.basicInformation.billingContactPersonRowTitle'),
    editButton: t('organizationSettingsPage.basicInformation.editButton'),
  };

  const organizationInformationEditModalTranslations: OrganizationInformationEditModalTranslations = {
    editModeTitle: t('organizationSettingsPage.basicInformationModal.editModeTitle'),
    nameTitle: t('organizationSettingsPage.basicInformationModal.nameTitle'),
    nameInputLabel: t('organizationSettingsPage.basicInformationModal.nameInputLabel'),
    billingAddressTitle: t('organizationSettingsPage.basicInformationModal.billingAddressTitle'),
    billingAddressText: t('organizationSettingsPage.basicInformationModal.billingAddressText'),
    streetAddressInputLabel: t('organizationSettingsPage.basicInformationModal.streetAddressInputLabel'),
    address1InputLabel: t('organizationSettingsPage.basicInformationModal.address1InputLabel'),
    address2InputLabel: t('organizationSettingsPage.basicInformationModal.address2InputLabel'),
    postalCodeInputLabel: t('organizationSettingsPage.basicInformationModal.postalCodeInputLabel'),
    invalidPostalCode: t('organizationSettingsPage.basicInformationModal.invalidPostalCode'),
    cityInputLabel: t('organizationSettingsPage.basicInformationModal.cityInputLabel'),
    countryInputLabel: t('organizationSettingsPage.basicInformationModal.countryInputLabel'),
    fieldRequired: t('organizationSettingsPage.basicInformationModal.fieldRequired'),
    billingContactTitle: t('organizationSettingsPage.basicInformationModal.billingContactTitle'),
    firstNameInputLabel: t('organizationSettingsPage.basicInformationModal.firstNameInputLabel'),
    lastNameInputLabel: t('organizationSettingsPage.basicInformationModal.lastNameInputLabel'),
    emailInputLabel: t('organizationSettingsPage.basicInformationModal.emailInputLabel'),
    invalidEmail: t('organizationSettingsPage.basicInformationModal.invalidEmail'),
    phoneNumberInputLabel: t('organizationSettingsPage.basicInformationModal.phoneNumberInputLabel'),
    invalidPhoneNumber: t('organizationSettingsPage.basicInformationModal.invalidPhoneNumber'),
    saveButton: t('organizationSettingsPage.basicInformationModal.saveButton'),
    closeButton: t('organizationSettingsPage.basicInformationModal.closeButton'),
    saveErrorTitle: t('organizationSettingsPage.basicInformationModal.saveErrorTitle'),
    saveErrorMessage: t('organizationSettingsPage.basicInformationModal.saveErrorMessage'),
    countries: {
      Finland: tGlobal('countries.Finland'),
      Sweden: tGlobal('countries.Sweden'),
      Norway: tGlobal('countries.Norway'),
      Denmark: tGlobal('countries.Denmark'),
      UnitedKingdom: tGlobal('countries.UnitedKingdom'),
    },
  };

  return (
    <>
      <OrganizationInformationCard
        translations={organizationInformationCardTranslations}
        organization={organization}
        onEditButtonClick={onClickEdit}
        countries={COUNTRIES}
      />
      <OrganizationInformationEditModal
        translations={organizationInformationEditModalTranslations}
        organization={organization}
        onOrganizationSave={updateOrganizationBasicInfo}
        onCloseModal={cancelOrganizationBasicInfo}
        countries={COUNTRIES}
        hidden={!showModal}
        fieldsConfig={[{ fieldName: 'organizationName', disabled: true }]}
      />
    </>
  );
};
